import { FetchResult } from '@apollo/client';
import graphClient from '../graphClient/graphClient';
import getCaregiverProfileQuery from './graphCaregiversQueries/getCaregiverProfileQuery';

const getCaregiverProfileGraph = async (id: number): Promise<FetchResult> => {
  return await graphClient.query({ query: getCaregiverProfileQuery, variables: { caregiverId: id } });
};

export default getCaregiverProfileGraph;
